module.exports = __webpack_public_path__ + "img/tc-crop-purple.df6e4ada.png";